<div style="min-width: 300px">
  <h3 class="color-slate-900 text-xl m-0">Loan Search</h3>

  <div class="p-inputgroup w-full flex flex-wrap pt-2 mb-2">
    <p-iconfield class="flex-1">
      <p-inputicon styleClass="pi pi-search" />
      <input
        pInputText
        [(ngModel)]="searchId"
        placeholder="{{ 'loanSearch.enterLoan' | translate }}..."
        mode="decimal"
        id="search-loan"
        inputStyleClass="pl-5"
        class="w-full h-full"
        (keyup.enter)="onEnteringLoanNumber()"
        data-testid="shared-loan-search-input"
      />
    </p-iconfield>
    <app-agility-button
      id="globalLoanSearchGoButton"
      buttonType="button"
      size="small"
      styleClass="ml-1"
      data-testid="global-loan-search-go-button"
      [label]="'loanSearch.go' | translate"
      [ariaLabel]="'loanSearch.go' | translate"
      (clicked)="onEnteringLoanNumber()"
    />
  </div>

  <div>
    @for (loan of searchedLoans(); track $index) {
      <app-global-loan-card
        class="mt-2"
        [loan]="loan"
        [data-success]="true"
      ></app-global-loan-card>
    }
    @if (loans().length > 0 || loadingSlots().length > 0) {
      <div class="color-surface-500 my-2 text-xs">
        {{ 'loanSearch.recentlyViewedLoans' | translate }}
      </div>
    }
    @if (showNotFoundMessage()) {
      <div class="my-2 text-xs text-center my-5 color-danger">
        {{ 'loanSearch.noResults' | translate }}
      </div>
    }
    @for (loan of loans(); track $index) {
      <app-global-loan-card
        [loan]="loan"
        [data-success]="true"
      ></app-global-loan-card>
    }
    @for (slot of loadingSlots(); track slot) {
      <app-global-loan-card [data-loading]="true"></app-global-loan-card>
    }
  </div>
</div>
